<template>
  <div>
    <SearchLicenses v-if="windowResize.width > 650" />
    <RotateScreen v-else />
  </div>
</template>

<script>
import SearchLicenses from '../components/search/SearchLicenses'
import { state, mutations } from '../components/Observables/searchLicenses'
import { useWindowResize } from '@sichern/ui-elements'
import RotateScreen from './RotateScreen'

export default {
  provide: { state, mutations },
  components: {
    SearchLicenses,
    RotateScreen
  },
  data() {
    return {
      windowResize: useWindowResize(this)
    }
  },
  created() {
    window.scrollTo(0, 0)
  }
}
</script>